import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";
import { COURSE } from "../../data/course";

export default function Curriculum() {
  return (
    <section id="curriculum" data-testid="curriculum-section" className="relative py-24 md:py-32">
      <div className="pointer-events-none absolute left-0 top-1/3 h-[420px] w-[420px] glow-blue opacity-50" />
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid gap-14 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <Reveal>
              <Eyebrow>The Curriculum</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-[#293891] sm:text-5xl">
                Nine phases.
                <br />
                One <span className="text-[#e63329]">career-ready</span> analyst.
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-8 max-w-sm text-base leading-relaxed text-[#566076]">
                A structured path from data foundations to autonomous AI analyst agents — every phase stacks on the last.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <div className="mt-8 flex items-center gap-6">
                <div>
                  <div className="font-display text-4xl font-semibold text-[#293891]">09</div>
                  <div className="text-xs uppercase tracking-[0.18em] text-[#566076]">Phases</div>
                </div>
                <div className="h-10 w-px bg-[#293891]/[0.05]" />
                <div>
                  <div className="font-display text-4xl font-semibold text-[#293891]">5</div>
                  <div className="text-xs uppercase tracking-[0.18em] text-[#566076]">Months</div>
                </div>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.15}>
            <Accordion type="single" collapsible defaultValue="item-0" className="w-full">
              {COURSE.curriculum.map((phase, i) => (
                <AccordionItem
                  key={phase.phase}
                  value={`item-${i}`}
                  data-testid={`curriculum-item-${i}`}
                  className="border-b border-[#293891]/10"
                >
                  <AccordionTrigger className="group py-6 text-left hover:no-underline">
                    <div className="flex items-center gap-5">
                      <span className="font-display text-sm text-[#e63329]">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="font-display text-xl font-medium text-[#293891] transition-colors group-hover:text-[#3B82F6] md:text-2xl">
                        {phase.phase}
                      </span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent>
                    <div className="grid grid-cols-1 gap-x-8 gap-y-2.5 pb-4 pl-10 sm:grid-cols-2">
                      {phase.topics.map((t) => (
                        <div key={t} className="flex items-start gap-3 text-sm text-[#566076]">
                          <span className="mt-1.5 h-1 w-1 shrink-0 rounded-full bg-[#e63329]" />
                          {t}
                        </div>
                      ))}
                    </div>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
